import makeList from './makeList.js'

let viewFloor = '清浄大気観測小屋'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '清浄大気観測小屋(1)',
        file: './data/I35a.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 57.84204671857619, 353.6510164789952 ],
          syowaZoom: [ 512.2494432071269, 360.8017817371938 ],
        },
      },
      { description: '清浄大気観測小屋(2)',
        file: './data/I35b.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 57.84204671857619, 353.6510164789952 ],
          syowaZoom: [ 465.47884187082406, 414.25389755011133 ],
        },
      },
      { description: '清浄大気観測小屋(3)',
        file: './data/I35c.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 57.84204671857619, 353.6510164789952 ],
          syowaZoom: [ 418.70824053452117, 483.2962138084632 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
